import { ActivatedRouteSnapshot, Resolve, Router } from "@angular/router";
import { forkJoin, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { LoanInfoDto, parseNumber } from "common";
import { AccountService } from "../../account/account.service";
import { AccountData } from "../../account/account.model";
import { SimulationTransactionData } from "../transaction.model";

export abstract class AccountTransactionSimulationResolver
  implements Resolve<SimulationTransactionData> {
  protected constructor(
    private readonly accountService: AccountService,
    private readonly router: Router
  ) {
  }

  resolve(
    route: ActivatedRouteSnapshot
  ):
    | Observable<SimulationTransactionData>
    | Promise<SimulationTransactionData>
    | SimulationTransactionData {
    const accountId = parseNumber(route.params.accountId);
    if (!accountId) {
      this.router.navigate(["error", "404"]);
      return;
    }

    return forkJoin([
      this.accountService.get(accountId),
      this.accountService.getInfo(accountId),
    ]).pipe(
      map(([accountData, loanInfoDto]: [AccountData, LoanInfoDto]) => (
        this.createSimulationTransactionData(accountData, loanInfoDto, accountId)
      ))
    );
  }

  protected abstract createSimulationTransactionData(accountData: AccountData, loanInfo: LoanInfoDto, accountId: number): SimulationTransactionData;
}